import React from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,makeStyles,
    TableFooter,TablePagination,IconButton,useTheme, Button  ,Menu, MenuItem
} from '@material-ui/core'
import { isEmpty, isUndefined} from 'lodash'
import NotybotEmptyTable from '../../../assets/images/notybot/notybot_empty_tabell.png'
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles1 = makeStyles((theme) => ({
    root: {
      // flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
    pageButtonActive: {
        height: 24,
        width: "auto",
        padding: '6px 8px',
        backgroundColor: '#009688',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        borderRadius: 6,
        color: '#fff',
        margin:'0 6px'
    },
    pageButton: {
        height: 24,
        width: "auto",
        padding: '6px 8px',
        backgroundColor: '#bdbdbd',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        borderRadius: 6,
        color: '#fff',
        margin:'0 6px'
    },
  }));

const useStyles = makeStyles({
    
    table: {
    minWidth: 'auto',
      width:"100%",
      minHeight: 100
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "#c6c6c6  !important",
        cursor: "pointer"
      },
      "&":{
        backgroundColor: "#EFEFEF  !important"
      }
    },
    tableRow1: {
      "&":{
        backgroundColor: "#EFEFEF  !important"
      },
    },
    tableRow2: {
      "&":{
        backgroundColor: "#EFEFEF  !important"
      },
      "&:hover": {
        backgroundColor: "#c6c6c6  !important",
      },
    },
    scrollBar: {
      overflowY: "auto",
      margin: 0,
      padding: 0,
      listStyle: "none",
      height: "100%",
      '&::-webkit-scrollbar': {
          height: '0.75em',
      },
      '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',   
      },
      '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.4)',
          outline: 'none',
          borderRadius: 15
      },
    },
  });

    // Nya pagenation Start
function MyTablePaginationActions(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleRowChange = (value) => {
      handleClose()
      props.onChangePageSize(value)
    }
    const handleClose = () => {
      setAnchorEl(null);
    };

    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage, pagginationExtended,KundWidth } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onChangePage(event, 0);
    };
  
    const handleBackButtonClick = (event) => {
      onChangePage(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onChangePage(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    const handleSetPage = (event, _page) => {
        onChangePage(event, _page);
    }

    const pageButtons = (activePageIndex) => {
     
        let NrPage = KundWidth === 3?2:5
        let totalButtons = Math.ceil(count / rowsPerPage) > NrPage ? NrPage : Math.ceil(count / rowsPerPage)
        let allPages = Math.ceil(count / rowsPerPage) 
        // console.log(totalButtons)
        let buttons = []
        let startIndex = KundWidth === 3?activePageIndex:activePageIndex > 2 ? activePageIndex - 2 : 0
       let newTotalbuttons = startIndex + totalButtons

        startIndex = (startIndex + NrPage-1) > allPages ? startIndex - ((allPages - activePageIndex) + 1) : startIndex
        // console.log(allPages)

        for(let index = startIndex; index <= newTotalbuttons; index++) {
            if(index < allPages && index >= 0)
                buttons.push(<button onClick={(e) => handleSetPage(e, index)} className={index === activePageIndex ? classes.pageButtonActive : classes.pageButton}><span>{index + 1}</span> </button>)
        }
        if(buttons.length < NrPage && allPages >= NrPage)
          buttons.unshift(<button onClick={(e) => handleSetPage(e, startIndex)} className={classes.pageButton}><span>{startIndex + 1}</span> </button>)
        if(buttons.length > NrPage)
          buttons.pop()
        return buttons
        
    }
  
    return (
      <div className={'w-100 d-flex justify-content-end align-items-center pt-3'}>
        {
          pagginationExtended ? 
          <div>
          <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} size="small" endIcon={<ArrowDropDownIcon />}>
            {rowsPerPage}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            size="small"
          >
            <MenuItem onClick={() => handleRowChange(10)}>10</MenuItem>
            <MenuItem onClick={() => handleRowChange(15)}>15</MenuItem>
            <MenuItem onClick={() => handleRowChange(25)}>25</MenuItem>
            <MenuItem onClick={() => handleRowChange(50)}>50</MenuItem>
            <MenuItem onClick={() => handleRowChange(75)}>75</MenuItem>
            <MenuItem onClick={() => handleRowChange(100)}>100</MenuItem>
          </Menu>
        </div>
          : ''
        }
        <span className="mr-2">
            {
                ((page * rowsPerPage) + 1) + ' - ' + 
                (((page + 1) * rowsPerPage) > count ? count : ((page + 1) * rowsPerPage)) 
                + ' av ' + count
            }
        </span>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          size="small"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page" size="small">
          <KeyboardArrowLeft />
        </IconButton>
        {pageButtons(page).map(b => b)}
        
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
          size="small"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
          size="small"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  }
  // Nya pagenation END

function NotyfileTable(props) {
    const classes = useStyles();
    const [page,setPage]=React.useState(props.page)
    const [paggination,setpaggination]=React.useState(isUndefined(props.paggination)?true:props.paggination)
    const [pagginationExtended,setpagginationExtended]=React.useState(isUndefined(props.pagginationExtended)?false:props.pagginationExtended)
    const [pageSize,setpageSize]=React.useState(props.pageSize)
    const [totalCount,settotalCount]=React.useState(props.totalCount)
    const [KundWidth,setKundWidth]=React.useState(isUndefined(props.KundWidth)?1:props.KundWidth)
    React.useEffect(()=>{
        if(page !== props.page){
            setPage(props.page)
            setpageSize(props.pageSize)
            settotalCount(props.totalCount)
        }
        if(!isEmpty(props.totalCount) && props.totalCount !==totalCount ){
            settotalCount(props.totalCount)
        }
    })
    return (
        <div style={{marginBottom:"1rem",width:"100%", ...props.style}}>
            <TableContainer className={classes.scrollBar} style={{ overflowX: props.ScrollX ? 'scroll' : 'hidden', overflowY: "hidden"}}>
      <Table className={classes.table} aria-label="simple_table">
        <TableHead>
          <TableRow 
          style={{height:"auto"}}>{props.columns.map((n,index)=>{
                      return <TableCell 
                       style={n.cellStyle} 
                       key={index}                       
                       width={isUndefined(n.width)?"auto":n.width}
                       padding={"none"}
                       colSpan={isUndefined(n.colSpan)?1:n.colSpan}
                       size="small"
                       >{n.title}</TableCell>})}
          </TableRow>
        </TableHead>
        <TableBody>{(!isEmpty(props.data)) ?props.data.map((n,index) => (<TableRow 
                        hover={isUndefined(props.OnClickRow)?!isUndefined(props.OnHover)?true:false:true}
                        className={isUndefined(props.OnClickRow)?!isUndefined(props.OnHover)?classes.tableRow2:classes.tableRow1:classes.tableRow}
                        role="checkbox" tabIndex={-1}
                        key={index}
                        onClick={(event) => {
                          if(!isUndefined(props.OnClickRow)){
                            props.OnClickRow(n,index)
                          }
                        }}
                        >{  n.map((c,index)=>(<TableCell colSpan={isUndefined(c.colSpan)?1:c.colSpan} key={index} size='small' width={c.width} style={c.CellStyle} height={isUndefined(props.RowHiehgt)?"46px":props.RowHiehgt} >{c.label}</TableCell>))
                            }
                        </TableRow>)
                    ) 
                 : ''
            }</TableBody>
        {
           !isUndefined(props.Hasfooter) ||  !isUndefined(props.hasSummaFooter)?
           
        <TableFooter>
            {
                !isUndefined(props.Hasfooter)?
                <TableRow>
                    {
                        props.newDate.map((c,index)=>(
                            <TableCell key={index} size='small' width={c.width} style={c.CellStyle} height={isUndefined(props.RowHiehgt)?"46px":props.RowHiehgt} >{c.label}</TableCell>
                            ))
                    }
                </TableRow>
                :""
            }
          <TableRow>
        </TableRow>
        {
          !isUndefined(props.hasSummaFooter)?
            <TableRow>{
            props.Footer.map((c,index)=>(
              <TableCell size='small' key={index} width={c.width} style={c.CellStyle} height={isUndefined(props.RowHiehgt)?"46px":props.RowHiehgt} >{c.label}</TableCell>
              ))
              }
            </TableRow>
          :""
        }
        </TableFooter>
        :""
      }
      </Table>
    </TableContainer>
    {
                  paggination===false?
                  <></>:
                // Gammla pagenation --> <TablePagination
                <MyTablePaginationActions
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                    classes={(props.totalCount > pageSize)?"":"d-none"}
                    colSpan={"100%"}
                    onChangePage={(e, pg) => {
                            props.setthisPage(pg+1)
                            setPage(pg+1)
                        }}
                    count={props.totalCount} 
                    pagginationExtended={pagginationExtended}
                    rowsPerPageOptions={[]}
                    page={page - 1} 
                    KundWidth={KundWidth} 
                    rowsPerPage={pageSize}
                    onChangePageSize={props.onChangePageSize}
                    // rowsPerPage={15}
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,   
                        }}
                    />
              }
        </div>
    );
}

export default NotyfileTable;